const getForgotPasswordUser = (state) => {return state.forgotPasswordUser }

const getForgotPasswordMessage = (state) => {return state.forgotPasswordMessage }
const getForgotPasswordError = (state) => {return state.forgotPasswordError }

const getResetPasswordMessage = (state) => {return state.resetPasswordMessage }
const getResetPasswordError = (state) => {return state.resetPasswordError }

export default { 
    getForgotPasswordUser,
    getForgotPasswordMessage,
    getForgotPasswordError,
    getResetPasswordMessage,
    getResetPasswordError,
    
}